import { getConditionalObject } from 'utils/data';

export const modalStyles = {
  '& .main': {
    '& .tabs:has(.Mui-selected:hover) .tabs-indicator': {
      borderColor: ({ palette }) => palette.background.primary,
      transition: 'none',
    },

    '& .tab': {
      padding: 0,

      '&.selected': {
        '& .label-text': {
          fontWeight: 700,
          color: ({ palette }) => palette.primary.main,
        },
      },

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
};

export const getNavigationTabLabelStyles = isDeleted => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  padding: '0 16px',
  width: '100%',
  height: '38px',
  textAlign: 'start',

  ...getConditionalObject(isDeleted, {
    textDecoration: 'line-through',
  }),

  '&:hover': {
    '& .label-text': {
      fontWeight: 700,
      color: ({ palette }) => palette.primary.main,
    },

    '& .label-button': {
      display: 'block',
    },
  },
});

export const labelTextContentStyles = {
  position: 'relative',
  width: '100%',
  flex: 1,
  overflow: 'hidden',
};

export const labelTextStyles = {
  fontSize: '1.2rem',
  lineHeight: '1.4rem',
  color: ({ palette }) => palette.text.secondary,
};

export const headTabLabelStyles = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  gap: '4px',
};

export const recordErrorIndicatorStyles = {
  display: 'flex',
  flexShrink: 0,
  marginRight: '8px',
};

export const labelButtonStyles = {
  display: 'none',
  height: '24px',
  width: '24px',
  padding: '5px',
  color: ({ palette }) => palette.primary.main,
  borderRadius: '4px',
  boxSizing: 'content-box',
};
